module Meevo.Components.Controls {

    interface IRatingControlComponentScope extends ng.IScope {
    }

    class MeevoRatingControlComponent implements ng.IComponentController {

        static $inject = [
            '$scope'
        ];

        public max: number;
        public model: number;
        public filledStars: number[];
        public emptyStars: number[];
        public tmpRating: number;

        constructor(private $scope: IRatingControlComponentScope) {
            this.max = 5;
            this.tmpRating = 0;
        }

        $onInit() {
            this.filledStars = _.range(1, this.max + 1, 1);
            this.emptyStars = _.range(1, this.max + 1, 1);
        }

        public isStarFilled(index: number): boolean {
            if (this.tmpRating > 0) {
                return index <= this.tmpRating;
            }
            return index <= this.model;
        }
    }

    angular.module('meevo.components.controls')
        .component('meevoRatingControlComponent', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/rating-control/rating-control.component.html',
            controller: MeevoRatingControlComponent,
            controllerAs: '$ctrl',
            bindings: {
                max: '<?',
                model: '=ngModel',
                disabled: '=ngDisabled'
            }
        });
}
